<template>
  <div class="productModal">
    <div
      class="modal fade show d-block overflow-auto"
      id="modalProduto"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalProdutoLabel"
      style="padding-right: 0.1em; display: block; z-index: 1045;"
      aria-modal="true"
    >
      <div class="modal-dialog modal-lg">
        <div
          class="modal-content"
          v-if="produto.id > 0 && processandoCarrinho === false"
        >
          <form>
            <div class="border-0 mb-0 modal-header pb-0 pt-2">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="toggleModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <carousel
                :per-page="1"
                :mouse-drag="true"
                :navigationEnabled="true"
                :loop="true"
              >
                <slide v-for="(img, index) of produto.imagemList" :key="index">
                  <div class="imgWithBackground">
                    <div
                      :style="{ 'background-image': urlImage(img.urlImagem) }"
                    ></div>
                    <div
                      :class="{
                        esgotado: !(produto.qtdEstoque > 0) && controleEstoque,
                      }"
                      :style="{ 'background-image': urlImage(img.urlImagem) }"
                    ></div>
                  </div>
                </slide>
              </carousel>
              <div class="lista_produtos">
                <div class="row">
                  <div class="col-lg-5">
                    <div class="item_produto item_semestral">
                      <div class="titulo_categoria d-flex flex-column">
                        <span>{{ produto.nome }}</span>
                      </div>
                      <div
                        class="mb-3"
                        v-if="
                          (produto.categoriaModificadorList || '').length > 0
                        "
                      >
                        <div
                          v-for="(modificador,
                          index) in produto.categoriaModificadorList"
                          :key="index"
                          class="mb-3"
                        >
                          <label
                            class="align-items-center d-flex justify-content-between m-0 p-2 w-100"
                            style="background-color: #dedede;"
                          >
                            <span>
                              <strong>{{ modificador.nome }}</strong>
                              <small class="d-block text-muted">
                                Escolha até {{ modificador.quantidadeMax }}
                              </small>
                            </span>
                            <span
                              class="badge badge-dark px-2 text-small text-uppercase"
                              style="letter-spacing: 0.035em;"
                              v-if="modificador.quantidadeMin > 0"
                            >
                              <small>obrigatório</small>
                            </span>
                          </label>
                          <label
                            :for="item.id"
                            v-for="(item,
                            indexMod) in modificador.produtoModificadorList"
                            :key="indexMod"
                            class="align-items-center d-flex justify-content-between m-0 p-2 w-100"
                          >
                            <div class="align-items-center d-flex justify-content-between flex-wrap m-0 p-2 w-100">
                              <div>
                                <span>{{ item.nome }}</span>
                                <small
                                  class="ml-2"
                                  v-if="item.valorUnitario > 0"
                                >
                                  (+&nbsp;{{ item.valorUnitario | currency }})
                                </small>

                                <small
                                  class="ml-2"
                                  v-if="item.valorFreteAdicional > 0"
                                >
                                  (+&nbsp;frete&nbsp;
                                  {{ item.valorFreteAdicional | currency }})
                                </small>
                              </div>
                              <div
                                v-if="modificador.quantidadeMax > 1"
                                class="row quantidade-modificador"
                              >
                                <div >
                                  <button
                                    type="button"
                                    class="col cin-btn cin-btn-1 cin-btn-md cin-decrement cor-principal"
                                    @click="addModificador(item, -1)"
                                  >
                                    -
                                  </button>

                                  <input
                                    type="number"
                                    class="cin-input basket-quantity margin-left:10px"
                                    :value="item.quantidade"
                                    readonly="true"
                                    @change="
                                      modificadorSelected(
                                        $event,
                                        modificador.quantidadeMax > 1,
                                        index,
                                      )
                                    "
                                  />
                                  <button
                                    type="button"
                                    class="col cin-btn cin-btn-1 cin-btn-md cin-increment cor-principal"
                                    @click="addModificador(item, 1)"
                                  >
                                    +
                                  </button>
                                </div>
                              </div>

                              <div
                                v-else
                                class="row quantidade-modificador-radio d-flex"
                              >
                                <input
                                  type="radio"
                                  v-model="categoriaModificador[index]"
                                  :id="item.id"
                                  :value="item.id"
                                  class="ml-2"
                                  :name="modificador.nome"
                                  @change="
                                    modificadorSelected(
                                      $event,
                                      modificador.quantidadeMax > 1,
                                      index,
                                    )
                                  "
                                />
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div class="plano" v-html="produto.descricaoCurta"></div>
                      <div class="valor">
                        <span class="preco">
                          Por:
                          {{
                            (produto.valorUnitario +
                              adicionalFrete +
                              adicionalValor)
                              | currency
                          }}
                        </span>
                        <span>{{ produto.unidadeMedida }}</span>
                      </div>
                      <div class="parcelamento">
                        <span class="parcelas">{{ produto.descParcelas }}</span>
                      </div>
                      <div class="quantidade d-flex justify-content-center">
                        <div class="custom-input-number">
                          <button
                            type="button"
                            class="cin-btn cin-btn-1 cin-btn-md cin-decrement cor-principal"
                            @click="adicionar(false)"
                          >
                            -
                          </button>
                          <input
                            type="number"
                            class="cin-input basket-quantity"
                            step="1"
                            :value="quantidade"
                            min="0"
                            max="20"
                            readonly="true"
                          />
                          <button
                            type="button"
                            class="cin-btn cin-btn-1 cin-btn-md cin-increment cor-principal"
                            @click="adicionar(true)"
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div class="valor">
                        <span class="preco">
                          Total:
                          {{
                            (quantidade *
                              (produto.valorUnitario +
                                adicionalFrete +
                                adicionalValor))
                              | currency
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-7 py-lg-3 pr-lg-4 px-4 pb-3 mx-2 m-lg-0 px-lg-0"
                  >
                    <span class="d-flex pb-2">
                      <img
                        class="mr-2"
                        :src="
                          produto.redeLoja.urlLogo ||
                          'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png'
                        "
                        :alt="produto.redeLoja.nome"
                        style="max-width: 36px;"
                      />
                      <small>
                        Vendido por:
                        <br />
                        <router-link
                          :to="{
                            name: 'loja',
                            params: { lojaId: produto.redeLoja.id },
                          }"
                          tag="a"
                        >
                          {{ produto.redeLoja.nome }}
                        </router-link>
                      </small>
                    </span>
                    <span
                      v-if="produto.descricao"
                      v-html="produto.descricao"
                    ></span>
                    <small
                      v-if="produto.regulamento"
                      class="d-block font-weight-bold pt-3"
                    >
                      Regulamento
                    </small>
                    <hr v-if="produto.regulamento" class="m-0" />
                    <small
                      v-if="produto.regulamento"
                      class="d-block overflow-auto py-3"
                      style="height: 200px;"
                      v-html="produto.regulamento.replace(/\\n/gm, '<br />')"
                    ></small>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div
            class="alert alert-danger alert-dismissible fade show mb-0"
            role="alert"
            v-if="erroQuantidade > 0"
          >
            <strong>Itens obrigatórios não selecionados.</strong>
            <button
              @click="erroQuantidade === 0"
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="toggleModal"
            >
              Fechar
            </button>
            <button
              type="button"
              class="btn btn_adicionar ml-auto"
              @click="adicionarProduto"
              :disabled="!(produto.qtdEstoque > 0) && controleEstoque"
            >
              Adicionar no carrinho
            </button>
          </div>
        </div>
        <div class="modal-content" v-else>
          <div class="modal-header d-flex flex-column align-items-center">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="toggleModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="d-flex justify-content-center align-items-center flex-column font-weight-bold my-5 py-5"
          >
            <img
              src="https://pagglo-cdn.s3.amazonaws.com/app/assets/loading-circle-carousel.svg"
              style="width: 80px;"
            />
            <div v-if="!processandoCarrinho">
              CARREGANDO INFORMAÇÕES DO PRODUTO
            </div>
            <div v-else>PROCESSANDO SEU CARRINHO DE COMPRAS</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" @click="toggleModal"></div>
  </div>
</template>

<script>
import { APIService } from '../APIService'
const apiService = new APIService()

export default {
  name: 'ProductModal',
  props: {
    objDetalhes: Object,
  },
  data() {
    return {
      adicionalFrete: 0,
      adicionalValor: 0,
      produto: Object,
      quantidadeInicial: this.objDetalhes.quantidade || 0,
      quantidade: this.objDetalhes.quantidade || 1,
      categoriaModificador: [],
      listaCarrosel: [
        'https://www.agguerreiro.com.br/media/catalog/category/banner_interno_ludangelo_3044x1240px.jpg',
      ],
      erroQuantidade: 0,
      controleEstoque: window.CONTROLE_ESTOQUE,
      loading: false,
      processandoCarrinho: false,
    }
  },
  mounted() {
    apiService.getProduct(this.objDetalhes.idProduto).then((response) => {
      this.produto = response
      this.produto.descricaoCurta = this.objDetalhes.objProduto.descricaoCurta
      this.produto.descParcelas = this.objDetalhes.objProduto.desParcelas
      this.produto.pontos = this.objDetalhes.objProduto.pontos

      if (response.descricao) {
        this.produto.descricao = response.descricao
          .replace(/oembed/g, 'iframe')
          .replace('url=', 'src=')
      }
    })
  },
  methods: {
    addModificador(item, quantidade) {
      if (!item.quantidade) {
        item.quantidade = 0
      }
      console.log(item)
      item.quantidade = item.quantidade + quantidade

      if (item.quantidade < 0) {
        item.quantidade = 0
      }
      console.log(item.quantidade)

      this.$forceUpdate()
    },
    adicionarProduto() {
      this.erroQuantidade = 0
      let modificadoresSelecionados = []

      if (
        this.quantidadeInicial === this.quantidade &&
        this.produto.qtdEstoque > 0 &&
        this.controleEstoque
      ) {
        this.toggleModal()
      } else {
        this.produto.categoriaModificadorList.forEach((e, i) => {
          const item = e.produtoModificadorList.filter(
            (tipo) => tipo.id === this.categoriaModificador[i],
          )

          if (typeof this.categoriaModificador[i] === 'object') {
            e.produtoModificadorList.forEach((e) => {
              if (this.categoriaModificador[i].includes(e.id)) {
                item.push(e)
              }
            })
          }

          if (
            +e.quantidadeMin === 0 ||
            (+e.quantidadeMin > 0 &&
              +item.length >= +e.quantidadeMin &&
              +item.length <= +e.quantidadeMax)
          ) {
            modificadoresSelecionados[i] = item
            //this.produto.categoriaModificadorList[i].produtoModificadorList = item;
          } else {
            this.erroQuantidade++
          }
        })

        if (this.erroQuantidade === 0) {
          this.atualizar()
        }
      }
    },
    addProdutoToLocalStorage() {
      ;(this.processandoCarrinho = true), (this.erroQuantidade = 0)
      let modificadoresSelecionados = []

      if (
        this.quantidadeInicial === this.quantidade &&
        this.produto.qtdEstoque > 0 &&
        this.controleEstoque
      ) {
        this.toggleModal()
      } else {
        this.produto.categoriaModificadorList.forEach((e, i) => {
          const item = e.produtoModificadorList.filter(
            (tipo) => tipo.id === this.categoriaModificador[i],
          )

          if (typeof this.categoriaModificador[i] === 'object') {
            e.produtoModificadorList.forEach((e) => {
              if (this.categoriaModificador[i].includes(e.id)) {
                item.push(e)
              }
            })
          }

          if (
            +e.quantidadeMin === 0 ||
            (+e.quantidadeMin > 0 &&
              +item.length >= +e.quantidadeMin &&
              +item.length <= +e.quantidadeMax)
          ) {
            modificadoresSelecionados[i] = item
            //this.produto.categoriaModificadorList[i].produtoModificadorList = item;
          } else {
            this.erroQuantidade++
          }
        })

        if (this.erroQuantidade === 0) {
          for (let i = 0; i < modificadoresSelecionados.length; i++) {
            this.produto.categoriaModificadorList[i].produtoModificadorList = []
            this.produto.categoriaModificadorList[i].produtoModificadorList =
              modificadoresSelecionados[i]
          }

          const objDetalhes = {
            produto: this.produto,
            quantidade: Math.abs(this.quantidadeInicial - this.quantidade),
          }

          this.$store
            .dispatch('pedidoAdicionarProduto', objDetalhes)
            .then(() => {
              // this.toggleModal();
            })
        }
      }
    },
    toggleModal() {
      ;(this.processandoCarrinho = false), this.$emit('toggleModal', false)
    },
    adicionar(add) {
      this.quantidade = add
        ? this.quantidade + 1
        : this.quantidade > 2
        ? this.quantidade - 1
        : 1
    },
    urlImage(url) {
      return `url('${
        url || 'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png'
      }')`
    },
    modificadorSelected(evt, checkbox, index) {
      if (checkbox) {
        if (typeof this.categoriaModificador[index] !== 'object') {
          this.categoriaModificador[index] = []
        }

        if (evt.target.checked) {
          if (!this.categoriaModificador[index].includes(+evt.target.value)) {
            this.categoriaModificador[index].push(+evt.target.value)
          }
        } else {
          this.categoriaModificador[index] = this.categoriaModificador[
            index
          ].filter((e) => +e !== +evt.target.value, [])
        }
      } else {
        this.categoriaModificador[index] = +evt.target.value
      }
      setTimeout(() => {
        this.calcAdicional()
      }, 100)
    },
    calcAdicional() {
      this.adicionalFrete = 0
      this.adicionalValor = 0
      this.produto.categoriaModificadorList.forEach((e) => {
        e.produtoModificadorList.forEach((el) => {
          this.categoriaModificador.forEach((mod) => {
            if (mod > 0) {
              if (+el.id === +mod) {
                this.adicionalFrete += el.valorFreteAdicional
                this.adicionalValor += el.valorUnitario
              }
            } else {
              mod.forEach((subMod) => {
                if (+el.id === +subMod) {
                  this.adicionalFrete += el.valorFreteAdicional
                  this.adicionalValor += el.valorUnitario
                }
              })
            }
          })
        })
      })
    },
    atualizarItensCarrinhoByToken(pedido, token) {
      apiService
        .atualizarItensCarrinhoByToken(pedido, token)
        .then((response) => {
          if (response) {
            this.$store.state.pedido.itens = response.itens
            localStorage.setItem('carrinho', JSON.stringify(response))
          }
          this.loading = false
          this.toggleModal()
        })
        .catch(() => (this.loading = false))
    },
    atualizarItensCarrinho(pedido) {
      apiService
        .atualizarItensCarrinho(pedido)
        .then((response) => {
          if (response) {
            this.$store.state.pedido.itens = response.itens
            localStorage.setItem('carrinho', JSON.stringify(response))
          }

          this.loading = false
        })
        .catch(() => (this.loading = false))
        .finally(() => this.toggleModal())
    },
    atualizar() {
      let token = localStorage.getItem('accessToken')

      if (!this.$store.state.user && token) {
        this.atualizarByToken(token)
      } else {
        this.atualizarByUserAuthenticate()
      }
    },
    atualizarByUserAuthenticate() {
      if (!this.$store.state.pedido.id) {
        if (!this.$store.state.user) {
          this.addProdutoToLocalStorage()
          this.toggleModal()
          return
        }

        apiService
          .getPedidoPendente()
          .then((response) => {
            if (!response) {
              this.addProdutoToLocalStorage()

              setTimeout(() => {
                const obj = {
                  redeLoja: {
                    codigoLoja:
                      this.$store.state.pedido.itens.length === 0
                        ? null
                        : this.$store.state.pedido.itens[0].produto.redeLoja
                            .codigoLoja,
                  },
                  itens: this.$store.state.pedido.itens,
                }

                if (this.$store.state.pedido.itens.length === 0) {
                  const carrinho = JSON.parse(localStorage.getItem('carrinho'))

                  obj.redeLoja.codigoLoja = carrinho.itens[0].produto.redeLoja
                  obj.itens = carrinho.itens
                }

                apiService
                  .cadastrarPedido(obj)
                  .then((response) => {
                    this.setPedidoToLocalStorage(response)
                    setTimeout(() => {
                      this.atualizarItensCarrinho(this.$store.state.pedido)
                    }, 500)
                  })
                  .catch(() => (this.loading = false))
                  .finally(() => this.toggleModal())
              }, 500)
            } else {
              apiService
                .getPedidoPendente()
                .then((response) => {
                  this.setPedidoToLocalStorage(response)
                  setTimeout(() => {
                    this.atualizarItensCarrinho(this.$store.state.pedido)
                  }, 500)
                })
                .catch(() => (this.loading = false))
            }
          })
          .catch(() => (this.loading = false))
      } else {
        this.addProdutoToLocalStorage()

        setTimeout(() => {
          this.atualizarItensCarrinho(this.$store.state.pedido)
        }, 200)
      }
    },
    atualizarByToken(token) {
      apiService.getPedidoPendenteByToken(token).then((response) => {
        if (!response || response.status !== 'AGUARDANDO_CHECKOUT') {
          this.addProdutoToLocalStorage()

          setTimeout(() => {
            const obj = {
              redeLoja: {
                codigoLoja:
                  this.$store.state.pedido.itens.length === 0
                    ? null
                    : this.$store.state.pedido.itens[0].produto.redeLoja
                        .codigoLoja,
              },
              itens: this.$store.state.pedido.itens,
            }

            if (this.$store.state.pedido.itens.length === 0) {
              const carrinho = JSON.parse(localStorage.getItem('carrinho'))

              obj.redeLoja.codigoLoja = carrinho.itens[0].produto.redeLoja
              obj.itens = carrinho.itens
            }

            apiService
              .cadastrarPedidoByToken(obj, token)
              .then((response) => {
                this.setPedidoToLocalStorage(response)

                setTimeout(() => {
                  this.toggleModal()
                }, 300)
              })
              .catch(() => (this.loading = false))
          }, 300)
        } else {
          ;(this.processandoCarrinho = true),
            this.setPedidoToLocalStorage(response)

          setTimeout(() => {
            this.addProdutoToLocalStorage()
          }, 200)

          setTimeout(() => {
            this.atualizarItensCarrinhoByToken(response, token)
          }, 200)
        }
      })
    },
    setPedidoToLocalStorage(pedido) {
      this.$store.state.pedido.itens = []
      this.$store.state.pedido.valorTotal = 0
      this.$store.state.pedido.valorFrete = 0
      this.$store.state.pedido.valorCompra = 0
      this.$store.state.pedido.valorDesconto = 0
      this.$store.state.pedido.id = null

      if (pedido.status === 'AGUARDANDO_CHECKOUT') {
        this.$store.state.pedido.itens = pedido.itens
        this.$store.state.pedido.valorTotal = pedido.valorTotal
        this.$store.state.pedido.valorFrete = pedido.valorFrete
        this.$store.state.pedido.valorCompra = pedido.valorCompra
        this.$store.state.pedido.valorDesconto = pedido.valorDesconto
        this.$store.state.pedido.id = pedido.id
      }

      setTimeout(() => {
        localStorage.setItem(
          'carrinho',
          JSON.stringify(this.$store.state.pedido),
        )
      }, 500)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.productModal {
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #efefef;
  }

  ::-webkit-scrollbar {
    width: 12px;
    background-color: #efefef;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #555;
  }
  .VueCarousel-navigation {
    position: relative;
    width: 100%;
  }
  .VueCarousel-navigation-next,
  .VueCarousel-navigation-prev {
    transform: translateY(-100%) translateX(0) !important;
    opacity: 0.4;
    margin: 0 !important;
    padding: 0 !important;
    height: 250px;
    width: 70px;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
  .imgWithBackground {
    position: relative;
    width: 100%;
    height: 250px;
    * {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-position: center;
      &:first-child {
        background-size: cover;
        filter: opacity(0.5) blur(2px);
      }
      &:last-child {
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }
  .cor-principal {
    color: var(--cor-principal) !important;
  }
  button.cor-principal:active {
    background: #ccc !important;
    border-color: transparent;
    color: #fff !important;
    box-shadow: 2px 2px 5px #fc894d;
  }
}
</style>
<style scoped lang="scss">
.esgotado:after {
  content: 'ESGOTADO';
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 52px !important;
  transform-origin: 50% 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-weight: bold;
  color: var(--cor-principal);
  text-shadow: 0 3px 6px black;
}
</style>
